export const SEND_REQUEST_STATUS = {
  PREPARING_TEMPLATE: 'PREPARING_TEMPLATE',
  SENDING: 'SENDING'
};

export const isSendRequestActive = task =>
  task?.status === SEND_REQUEST_STATUS.SENDING;

export const isSendAwaitingTemplate = task =>
  task?.status === SEND_REQUEST_STATUS.PREPARING_TEMPLATE;

export const isSendRequestProcessing = task => Boolean(task);

export const createSendRequestTask = ({
  status,
  fromDocView = false,
  tillPage,
  noProgressDialog = false,
  skipThankyou = false
} = {}) => ({
  status,
  fromDocView,
  tillPage,
  noProgressDialog,
  skipThankyou
});
